import { Controller } from "@api/config";

import type { IDeleteRemarkRequest, IGetRemarkListRequest, IPostRemarkRequest } from "./request.types";
import { TGetRemarkListResponse } from "./response.types";

class RemarksController extends Controller {
	public constructor() {
		super({ requestUrl: "models/remark" });
	}

	/**@GET REMARK LIST */
	public async getRemarkList({
		token,
		offset = 0,
		limit = 10,
		sortOrder = "desc",
		sortField = "createdAt",
		query = "",
	}: IGetRemarkListRequest) {
		return this.get<TGetRemarkListResponse>(
			"base",
			`?offset=${offset}&limit=${limit}&sortOrder=${sortOrder}&sortField=${sortField}${query ? `&query=${query}` : ""}`,
			{ token },
		);
	}

	/** @POST CREATE REMARK */
	public async createRemark({ token, userId, remark }: IPostRemarkRequest) {
		return this.post<{ id: number } | { code: number; message: string }>("", { userId, remark }, { token });
	}

	/** @PUT UPDATE REMARK */
	public async updateRemark({ token, userId, remark }: IPostRemarkRequest) {
		return this.put<{ id: number } | { code: number; message: string }>("", { userId, remark }, { token });
	}

	/** @DELETE REMARK */
	public async deleteRemark({ token, id }: IDeleteRemarkRequest) {
		return this.delete<void>(`/${id}`, { token });
	}
}

export const remarksAPI = new RemarksController();
